import { useCallback } from "react";
import { canv } from "@/canv/global";
import type { ActiveSubMenuState, SetActiveSubMenu } from "../../types";
import { SubMenu } from "../SubMenu/SubMenu";
import { FilterMenuContent } from "./FilterMenuContent";

interface FilterMenuProps {
    activeSubMenu: ActiveSubMenuState;
    setActiveSubMenu: SetActiveSubMenu;
}

export function FilterMenu({ activeSubMenu, setActiveSubMenu }: FilterMenuProps) {
    const handleButtonClick = useCallback(
        (entityType: string) => {
            canv.canvasController.filterCheckedByEntityType(entityType);
            setActiveSubMenu(null);
        },
        [setActiveSubMenu],
    );

    return (
        <SubMenu align="stretch" activeSubMenu={activeSubMenu}>
            <FilterMenuContent onClick={handleButtonClick} />
        </SubMenu>
    );
}
